import { Check, Video, UtensilsCrossed, ListChecks, Dumbbell, Brain, ArrowRight } from 'lucide-react';
import { pushToDataLayer } from '../utils/gtm';

export default function Value() {
  const features = [
    { icon: Video, text: 'Komplettes 7-Tage-Body-Boost-Programm (über 40 Videos)', value: '199 €' },
    { icon: UtensilsCrossed, text: 'Ernährungspläne (normal, vegetarisch, vegan)', value: '79 €' },
    { icon: ListChecks, text: 'Einkaufslisten & Rezept-Guides', value: '39 €' },
    { icon: Dumbbell, text: '7 Workouts à 30 Minuten', value: '79 €' },
    { icon: Brain, text: 'Stress- & Schlafmanagement-Training', value: '29 €' },
    { icon: Brain, text: 'Bonus: Mindset- & Neuroplastizitäts-Coaching', value: '25 €' },
  ];

  const totalValue = features.reduce((sum, feature) => {
    return sum + parseInt(feature.value.replace(/[^0-9]/g, ''));
  }, 0);

  return (
    <section className="relative py-20 lg:py-32 bg-gradient-to-b from-white to-green-50 overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              Was du bekommst
            </h2>
            <p className="text-xl text-gray-600">
              Gesamtwert: <span className="font-bold text-gray-900">450 €</span>
            </p>
          </div>

          <div className="space-y-4">
            {features.map((feature, i) => (
              <div
                key={i}
                className="flex items-center gap-4 bg-white/95 backdrop-blur-sm p-5 lg:p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 lg:w-14 lg:h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-6 h-6 lg:w-7 lg:h-7 text-green-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-gray-900 font-medium text-sm lg:text-base">{feature.text}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-lg lg:text-xl font-bold text-gray-900">{feature.value}</p>
                </div>
              </div>
            ))}

            <div className="bg-gradient-to-r from-gray-900 to-gray-800 p-6 lg:p-8 rounded-2xl shadow-xl">
              <div className="flex items-center justify-between">
                <p className="text-white font-bold text-xl lg:text-2xl">Gesamtwert</p>
                <p className="text-3xl lg:text-4xl font-bold text-green-400">{totalValue} €</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl p-6 lg:p-8 text-white shadow-2xl">
            <div className="space-y-6">
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold mb-2">Dein Preis heute</h3>
                <div className="w-16 h-1 bg-green-400 rounded" />
              </div>

              <div className="space-y-3">
                <div className="flex items-baseline gap-3 flex-wrap">
                  <span className="text-5xl lg:text-6xl font-bold">49 €</span>
                  <span className="text-4xl lg:text-5xl line-through text-green-300 opacity-70">149 €</span>
                </div>
                <p className="text-lg lg:text-xl text-green-100 font-semibold">
                  Nur die ersten 100 erhalten den Rabattpreis von 49 €.
                </p>
                <p className="text-lg lg:text-xl text-green-100">
                  oder <span className="font-bold text-white">0 €</span>, wenn du 5 kg verlierst.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 lg:p-6 border-2 border-white/20">
                <p className="text-base lg:text-lg leading-relaxed">
                  Coaching-Wissen aus 20 Jahren Erfahrung – komprimiert in 7 Tagen – für weniger als eine Personal-Training-Stunde.
                </p>
              </div>

              <a
                href="https://www.digistore24.com/product/642539/siebentage5kilo/?ds24_domain=www.digistore24.com&voucher=7TageStart"
                className="group block w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white py-4 lg:py-5 px-6 rounded-xl font-bold text-lg lg:text-xl transition-all duration-300 shadow-lg hover:shadow-xl text-center"
                onClick={() => pushToDataLayer('initiate_checkout')}
              >
                <span className="flex items-center justify-center gap-2">
                  Aktionspreis sichern – solange Plätze frei sind
                  <ArrowRight className="w-5 h-5 lg:w-6 lg:h-6 group-hover:translate-x-2 transition-transform" />
                </span>
              </a>

              <div className="flex flex-col items-center gap-2 text-sm text-green-100">
                <div className="flex items-center gap-2">
                  <Check className="w-4 h-4" />
                  <span>Sofortiger Zugang</span>
                </div>
                <p className="text-xs text-center">Nur 100 Plätze – danach 149 €.</p>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-gray-100 rounded-xl p-5 lg:p-6 text-sm text-gray-600 leading-relaxed">
            <p>
              Gesunder Gewichtsverlust liegt bei 1 kg pro Woche. Normale Ergebnisse für stark Übergewichtige: 2 – 5 kg. Wichtiger ist, dass du dich besser fühlst.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
